<template>
    <section class='password-keyboard'>
        <div class="keyboard__wrapper">    
            <div class="keyboard-title">
                安全键盘
                <span class="hidden-button" :class="{'is-hidden':isHidden}" @click="isHidden=!isHidden"></span>
            </div>
            <div class="keyboard-keys wui-border-1px" :class="{'keys-hidden':isHidden}">
                <w-row v-for="line in keys" :key="line.$index">
                    <w-cell class="keyboard-key" :class="{'empty-key':value===null,'delete-key':value==='delete'}" v-for="{text,value} in line" :key="text" vertical-align="center" align="center" @click.native="handleClick(value)"><span class="keyboard-button">{{text}}</span></w-cell>
                </w-row>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                isHidden: false,
                keys: [
                    [{
                        text: '1',
                        value: 1
                    }, {
                        text: '2',
                        value: 2
                    }, {
                        text: '3',
                        value: 3
                    }],
                    [{
                        text: '4',
                        value: 4
                    }, {
                        text: '5',
                        value: 5
                    }, {
                        text: '6',
                        value: 6
                    }],
                    [{
                        text: '7',
                        value: 7
                    }, {
                        text: '8',
                        value: 8
                    }, {
                        text: '9',
                        value: 9
                    }],
                    [{
                        text: '',
                        value: null
                    }, {
                        text: '0',
                        value: 0
                    }, {
                        text: '',
                        value: 'delete'
                    }]
                ]
            }
        },
        methods: {
            handleClick(value) {
                this.$emit("input", value);
            }
        }
    }
</script>
<style lang='sass' scoped>
    @import '../../assets/sass/media.scss';

    $keyboardHeight:50px;
    $introFontColor:#999999;
    $titleFontColor:#222222;
    
    .keyboard-title {
        background: #f5f7f9;
        box-shadow: 0 0 0 0 #d9d9d9, 0 0 0 0 #d9d9d9, inset 0 0 0 0 #d9d9d9;
        width: 100%;
        height: 32px;
        font-size: 14px;
        color: $introFontColor;
        line-height: 32px;
        text-align: center;
        position: relative;
        .hidden-button {
            position: absolute;
            height: 32px;
            width: 40px;
            top: 0;
            right: 0;
            &:after {
                content: "";
                height: 10px;
                width: 10px;
                border-right: 1px solid #c0c0c0;
                border-bottom: 1px solid #c0c0c0;
                position: absolute;
                right: 15px;
                top: 40%;
                transition: transform ease 0.5s 0.4s;
                transform: rotateZ(45deg);
            }
        }
        .hidden-button.is-hidden:after {
            transform: rotateZ(225deg);
        }
    }
    
    .keyboard-keys {
        height: $keyboardHeight*4;
        transition: height ease 0.5s;
        overflow: hidden;
        @include respond-to(ip4) {
            height: $keyboardHeight*4*0.8
        }
        &.keys-hidden {
            height: 0px;
        }
    }
    
    .keyboard-key {
        height: $keyboardHeight;
        @include respond-to(ip4) {
            height: $keyboardHeight*0.8
        }
        background-color: #fff;
        position: relative;
        
        &.delete-key,
        &.empty-key {
            background-color: #f5f7f9;
            box-shadow: 0 0 0 0 #d9d9d9, 0 0 0 0 #d9d9d9, inset 0 0 0 0 #d9d9d9, inset 0 0 0 0 #d9d9d9;
        }
        &:not(.empty-key):active {
            background-color: #e2e5ea;
            box-shadow: 0 0 0 0 #d9d9d9, 0 0 0 0 #d9d9d9, inset 0 0 0 0 #d9d9d9, inset 0 0 0 0 #d9d9d9;
        }
        &.delete-key {
            background-image: url('../../assets/imgs/delete.png');
            background-repeat: no-repeat;
            background-position: 50% 50%;
            background-size: 40px;
            font-size: 16px;
        }
        &.delete-key:not(.empty-key):active {
            background-image: url('../../assets/imgs/delete-hover.png');
        }
    }
    
    .keyboard-button {
        width: 100px;
        font-size: 30px;
        color: $titleFontColor;
        height: $keyboardHeight;
        line-height: $keyboardHeight;
        text-align: center;
        @include respond-to(ip4) {
            height: $keyboardHeight*0.8;
            line-height: $keyboardHeight*0.8;
        }
    }
</style>


// WEBPACK FOOTER //
// number-keyboard.vue?6aa9aaf8